import { DefaultService } from '@/services/DefaultService';

export default class ClienteService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    loadNameVendas(id) {
		return this._http.get(`${this._env}/vendas/cliente/name?id=${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadNameAgro(id) {
		return this._http.get(`${this._env}/agro/cliente/name?id=${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(form) {
		return this._http.post(`${this._env}/vendas/cliente`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(form) {
		return this._http.post(`${this._env}/agro/cliente`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findVendas(id) {
        return this._http.get(`${this._env}/ven/cliente/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAgro(id) {
        return this._http.get(`${this._env}/agro/cliente/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getStatusClienteComboEdit() {
        return this._http.get(`${this._env}/vendas/cliente/getcombo/edit/status.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page = 0, limit = 50, sort, column, filtroCliente) {
        return this._http.post(`${this._env}/cliente/all.json?page=${page}&sort=${sort}&column=${column}&limit=${limit}`, filtroCliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(data) {
		return this._http.post(`${this._env}/vendas/cliente/updatesituacao`, data, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    getInfoByCNPJ(uf, cnpj) {
        return this._http.get(`${this._env}/general/cnpj.json?uf=${uf}&cnpj=${cnpj}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getInfoByCEP(cep, token) {
        return this._http.post(`${this._env}/consultacep/${cep}`, {token: token},
            {'Content-Type': 'application/json'}
        ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateLocation (cliente) {
        return this._http.post(`${this._env}/cliente/location`, cliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(params) {
        return this.findAllComboSituacao(3, params);
    }
    // filtra situação pelo replicapda
    findAllComboSituacao(situacao = 3, ...params) {
        return this._http.get(`${this._env}/getcombo/cliente.json?situacao=${situacao}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}